import { Tabs, Box, Grid, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function FileTabBar(props) {
  return (
    <>
      <Box>
        <Grid container columns={{ xs: 30, sm: 30, md: 30 }}>
          <Grid item xs={1} /* sx={{ paddingRight: "5px", borderBottom: "solid 1px #c8c8c85c" }} */>
            <div
              onClick={() => props.handleClickAddFile()}
              style={{
                textWrap: "nowrap",
                backgroundColor: props.enableAddFileButton
                  ? "transparent"
                  : "rgba(109, 109, 109, 0.12)",
                position: props.selected ? "relative" : "unset",
                zIndex: props.selected ? "99" : "unset",
                color: "#a6a6a6",
                height: "100%",
                width: "100%",
                boxSizing: "border-box",
                paddingTop: "15px",
                paddingLeft: "19px",
                /* borderRadius: "2px 2px 0 0", */
                cursor: "pointer",
                borderRight: "1px solid rgba(109, 109, 109, 0.12)",
                borderTop: props.enableAddFileButton
                  ? "solid 3px #ff5722"
                  : "solid 3px transparent",
                borderBottom: "solid 1px #c8c8c85c",
              }}
            >
              <AddIcon fontSize="inherit" />
            </div>
          </Grid>
          <Grid item xs={29}>
            <Tabs
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{
                sx: {
                  top: 0, // move o indicador para cima
                  bottom: "unset",
                },
              }}
              sx={{ borderBottom: "solid 1px #c8c8c85c" }}
            >
              {props.children}
            </Tabs>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
